<template>
  <layout>
    <div class="mc-invoice-delivery-list">
      <PageHeader :title="title" :subTitle="subTitle">
        <template #afterTitle>
          <div class="d-flex gap-2">
            <McButtonBack />
            <McButton
              variant="primary"
              :text="`${$t('global.action.apply')} ${$t('global.delivery')}`"
              icon="icon-outline_arrow-right"
              iconPosition="right"
              @click="$router.push({name: 'Invoice Form'})"
            />
          </div>
        </template>
      </PageHeader>
      <McTable 
        :fields="fields"
        :apiClient="apiClient"
        :hasSelectAll="false"
        :hasDelete="false"
        :hasViewManager="true"
        :activeFilters="activeFilters"
        stickyHeader
        withCard
        searchable
      >
        <template #beforeSearchBar>
          <template>
            <McTableFilter
            class="d-flex justify-content-end"
            :activeFilters="activeFilters"
            :parseFilterDataMappings="parseFilterDataMappings"
            @submit="handleChangeActiveFilters"
          >
            <template #content="{ formValues, updateFormValues, fullObjects, updateFullObjects }">
              <InputTableFilter
                :formValues="formValues"
                :fullObjects="fullObjects"
                @update:formValues="updateFormValues($event)"
                @update:fullObjects="updateFullObjects($event)"
              />
            </template>
          </McTableFilter>
          </template>
        </template>
        <template #cell(created_on)="{ value }">
          <template>
            <div>{{ formatIndexDate(value).date }}</div>
            <div class="mc-datetime">{{ formatIndexDate(value).time }}</div>
          </template>
        </template>
        <template #cell(status.name)="{ value, item }">
          <template>
            <span
              v-if="item.status?.color"
              class="__status-dots"
              :style="{ backgroundColor: item.status.color }"
            ></span>
            <span class="mc-text-status">{{ value }}</span>
          </template>
        </template>
      </McTable>
    </div>
  </layout>
</template>
<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import McButtonBack from '@/components/McButtonBack'
import McButton from '@/components/McButton'
import McTable from '@/components/McTable'
import McTableFilter from '@/components/McTableFilter'
import InputTableFilter from './components/InputDeliveryTableFilter'

import * as Delivery from '@/services/rest-api/lib/delivery/delivery-order'

import { listTableFields } from './lib/fields/listTableFields'
import filterMappings from './lib/constants/delivery-invoice/filter-mappings'
import parseFilterDataMappings from './lib/constants/delivery-invoice/parse-filter-data-mappings'
import { formatIndexDate } from '@/helpers/tzDate'

export default {
  page: {
    title: 'Invoice Create',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    McButton,
    McTable,
    McTableFilter,
    InputTableFilter,
  },
  mixins: [ listTableFields ],
  data() {
    return {
      activeFilters: {},
      params: {},
    }
  },
  computed: {
    title() {
      return this.$t("invoice.title.deliveryInvoiceCreate")
    },
    subTitle() {
      return this.$t("invoice.subtitle.deliveryInvoiceCreate")
    },
    fields() {
      return this.listTableFields.filter(field => !field.isShow)
    },
    apiClient() {
      let getDeliveryOrder = Delivery.get(
        null,
        this.handleSetParams
      )

      if (Object.keys(this.activeFilters).length > 0) {
        let queryParamFilters = []

        Object.keys(this.activeFilters).forEach((key) => {
          const filter = filterMappings[key]?.(key, this.activeFilters[key]) ?? undefined
          queryParamFilters.push(filter)
          
          getDeliveryOrder = Delivery.get(
            queryParamFilters,
            this.handleSetParams
          )
        })
      }

      return {
        get: getDeliveryOrder,
      }
    },
    parseFilterDataMappings() {
      return parseFilterDataMappings
    }
  },
  methods: {
    formatIndexDate,
    handleChangeActiveFilters(filters) {
      filters.forEach((filter) => {
        this.$delete(this.activeFilters, filter.key)

        if (filter.values === null || filter.values === undefined || filter.values === '') return

        if (Array.isArray(filter.values) && filter.values.length === 0) return

        this.$set(this.activeFilters, filter.key, filter.values)
      })
    },
    handleSetParams(params) {
      this.params = params
    }
  }
}
</script>

<style lang="scss" scoped>
.mc-invoice-delivery-list {
  .__status-dots {
    display: inline-block;
    margin: auto;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
  }
}
</style>
